// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__31Y5E","notes":"Notes_notes__2qZOu","note":"Notes_note__2HJmc","markdown":"Notes_markdown__1p611"};